<template>
  <div class="pt-5 pl-3 pr-3">
    <div class="summary">
      <h3 class="tNormal">کاربران</h3>
      <h5 class="tNormal mt-3 mini-title">تعداد کل :</h5>
      <h5 class="mini-title mr-2 tNormal mt-3">{{ total_users }}</h5>
      <div class="search-section">
        <!-- <custom-input
          kind="text"
          container="mini-title ml-5 mt-5"
          classes="mini-title mr-2"
          v-bind:theModel.sync="userMobile"
          label="جستجوی کاربر"
          placeholder="شماره موبایل"
        ></custom-input> -->
         <v-text-field v-model="userMobile"></v-text-field>
        <button class="purple-btn" @click="searchUser">جستجو</button>
        <!-- <button class="purple-btn mr-2" @click="showAll">نمایش همه</button> -->
      </div>
      <div class="mt-2" v-if="searchError == ''">
        <div class="headline clearfix">
          <div class="small-cell">نام</div>
          <div class="small-cell">تاریخ ثبت نام</div>
          <div class="small-cell">شماره تلفن</div>
          <div class="small-cell">تعداد سفارش</div>
          <div class="small-cell">محله</div>
          <div class="small-cell">توضیحات</div>
          <div class="small-cell">ابزار</div>
        </div>
        <OneUser
          @goToPanel="goToPanel"
          v-for="(u, i) in searchUsers !== null ? searchUsers : users"
          :key="i"
          :theUser="u"
        />
      </div>
      <div v-else>{{ searchError }}</div>
    </div>
    <div v-if="current_page" class="text-center py-2">
      <button
        v-if="current_page !== all_data.last_page"
        class="page-keys"
        @click="last(last_page)"
      >
        {{ last_page }}
      </button>
      <span v-if="current_page !== all_data.last_page">...</span>
      <button
        v-if="current_page !== all_data.last_page"
        class="page-keys"
        @click="next()"
      >
        بعدی
      </button>
      <button
        v-if="current_page !== all_data.last_page"
        class="page-keys"
        @click="one_more(current_page + 1)"
      >
        {{ current_page + 1 }}
      </button>
      <button class="page-keys active">{{ current_page }}</button>
      <button
        v-if="current_page - 1"
        class="page-keys"
        @click="one_less(current_page - 1)"
      >
        {{ current_page - 1 }}
      </button>
      <button v-if="current_page - 1" class="page-keys" @click="preview()">
        قبلی
      </button>
    </div>
    <div class="text-center py-1">
      <button class="go-to-btn" @click="go_to()">برو صفحه</button>
      <div class="d-inline-block">
        <input class="go-to-input" v-model="go_page" type="text" />
      </div>
    </div>
  </div>
</template>
<script>
import { computed, onMounted, ref, inject } from "@vue/composition-api";
import OneUser from "./partials/user";
import Service from "../../../utils/admin-service";
import CustomInput from "../../Common/CustomInput";
import jalalim from "jalali-moment";
export default {
  components: {
    OneUser,
    CustomInput,
  },
  setup(props, context) {
    const users = ref([]);
    const go_page = ref();
    const current_page = ref("");
    const last_page_url = ref("");
    const last_page = ref("");
    const next_page_url = ref("");
    const prev_page_url = ref("");
    const total_users = ref();
    const page = ref(1);
    const all_data = ref();
    const global = inject("global");
    const theService = computed(() => {
      return Service(false);
    });

    onMounted(() => {
      theService.value.receive(
        "admin/user",
        {},
        (s, d) => {
          all_data.value = d.data;
          total_users.value = d.data.total;
          last_page_url.value = d.data.last_page_url.replaceAll(
            "https://api.golpino.com/api",
            ""
          );
          next_page_url.value = d.data.next_page_url.replaceAll(
            "https://api.golpino.com/api",
            ""
          );
          users.value = d.data.user;
          current_page.value = d.data.current_page;
          last_page.value = d.data.last_page;
          users.value.map((u) => {
            u.date = jalalim(u.register_time).locale("fa").format("YYYY/MM/DD");
          });
        },
        (s, e) => {}
      );
    });
    const next = function () {
      theService.value.receive(
        next_page_url.value,
        {},
        (s, d) => {
          last_page_url.value = d.data.last_page_url.replaceAll(
            "https://api.golpino.com/api",
            ""
          );
          if(d.data.next_page_url){
            next_page_url.value = d.data.next_page_url.replaceAll(
            "https://api.golpino.com/api",
            ""
          );
          }
          prev_page_url.value = d.data.prev_page_url.replaceAll(
            "https://api.golpino.com/api",
            ""
          );

          users.value = d.data.user;
          current_page.value = d.data.current_page;
          last_page.value = d.data.last_page;
          users.value.map((u) => {
            u.date = jalalim(u.register_time).locale("fa").format("YYYY/MM/DD");
          });
        },
        (s, e) => {}
      );
    };
    const preview = function () {
      console.log(prev_page_url.value);
      if (prev_page_url.value) {
        theService.value.receive(
          prev_page_url.value,
          {},
          (s, d) => {
            last_page_url.value = d.data.last_page_url.replaceAll(
              "https://api.golpino.com/api",
              ""
            );
            next_page_url.value = d.data.next_page_url.replaceAll(
              "https://api.golpino.com/api",
              ""
            );
            if (d.data.prev_page_url) {
              prev_page_url.value = d.data.prev_page_url.replaceAll(
                "https://api.golpino.com/api",
                ""
              );
            }

            users.value = d.data.user;
            current_page.value = d.data.current_page;
            last_page.value = d.data.last_page;
            users.value.map((u) => {
              u.date = jalalim(u.register_time)
                .locale("fa")
                .format("YYYY/MM/DD");
            });
          },
          (s, e) => {}
        );
      }
    };
    const one_more = function (one_more_page) {
      theService.value.receive(
        "/admin/user?page=" + one_more_page,
        {},
        (s, d) => {
          last_page_url.value = d.data.last_page_url.replaceAll(
            "https://api.golpino.com/api",
            ""
          );
          if (next_page_url) {
            next_page_url.value = d.data.next_page_url.replaceAll(
              "https://api.golpino.com/api",
              ""
            );
          }

          if (prev_page_url) {
            prev_page_url.value = d.data.prev_page_url.replaceAll(
              "https://api.golpino.com/api",
              ""
            );
          }

          users.value = d.data.user;
          current_page.value = d.data.current_page;
          last_page.value = d.data.last_page;
          users.value.map((u) => {
            u.date = jalalim(u.register_time).locale("fa").format("YYYY/MM/DD");
          });
        },
        (s, e) => {}
      );
    };
    const one_less = function (one_less_page) {
      theService.value.receive(
        "/admin/user?page=" + one_less_page,
        {},
        (s, d) => {
          last_page_url.value = d.data.last_page_url.replaceAll(
            "https://api.golpino.com/api",
            ""
          );
          next_page_url.value = d.data.next_page_url.replaceAll(
            "https://api.golpino.com/api",
            ""
          );
          if (d.data.prev_page_url) {
            prev_page_url.value = d.data.prev_page_url.replaceAll(
              "https://api.golpino.com/api",
              ""
            );
          }

          users.value = d.data.user;
          current_page.value = d.data.current_page;
          last_page.value = d.data.last_page;
          users.value.map((u) => {
            u.date = jalalim(u.register_time).locale("fa").format("YYYY/MM/DD");
          });
        },
        (s, e) => {}
      );
    };
    const last = function (last_page) {
      theService.value.receive(
        "/admin/user?page=" + last_page,
        {},
        (s, d) => {
          prev_page_url.value = d.data.prev_page_url.replaceAll(
            "https://api.golpino.com/api",
            ""
          );

          users.value = d.data.user;
          current_page.value = d.data.current_page;
          users.value.map((u) => {
            u.date = jalalim(u.register_time).locale("fa").format("YYYY/MM/DD");
          });
        },
        (s, e) => {}
      );
    };
    // const userMobile = ref({ value: null, valid: true });
    const userMobile = ref(null);
const searchUser_data = ref(null);
    const searchError = ref("");

    // const searchUser = () => {
    //   searchError.value = "";
    //   let x = users.value.filter((u) => {
    //     if (u.mobile == userMobile.value.value) return u;
    //   });
    //   searchUsers.value = x;
    //   if (searchUsers.value.length == 0) {
    //     searchError.value = "کاربری با این مشخصات یافت نشد";
    //   }
    // };
    const goToPanel = (id) => {
      theService.value.receive(
        "admin/user/return/token/" + id,
        {},
        (s, d) => {
          global.setUserType("user");
          document.cookie =
            "Golpino_token=" + d.data + ";path=/;domain=golpino.com";
          window.open("https://golpino.com", "_blank");
        },
        (s, e) => {}
      );
    };
    const go_to = function () {
      theService.value.receive(
        "https://api.golpino.com/api/admin/user?page=" + go_page.value,
        {},
        (s, d) => {
          last_page_url.value = d.data.last_page_url.replaceAll(
            "https://api.golpino.com/api",
            ""
          );
          if (d.data.next_page_url) {
            next_page_url.value = d.data.next_page_url.replaceAll(
              "https://api.golpino.com/api",
              ""
            );
          }
          if (d.data.prev_page_url) {
            prev_page_url.value = d.data.prev_page_url.replaceAll(
              "https://api.golpino.com/api",
              ""
            );
          }

          users.value = d.data.user;
          current_page.value = d.data.current_page;
          last_page.value = d.data.last_page;
          users.value.map((u) => {
            u.date = jalalim(u.register_time).locale("fa").format("YYYY/MM/DD");
          });
        },
        (s, e) => {}
      );
    };
    const searchUsers = computed(() => {
      return searchUser_data.value;
    });
    const searchUser = () => {
         theService.value.receive(
        "https://api.golpino.com/api/admin/user/search?mobile=" + userMobile.value,
        {},
        (s, d) => { 
            searchUser_data.value =d;
         },
        (s, e) => {}
      );
    }

    
    return {
      users,
      userMobile,
      searchUsers,
      searchUser,
      // showAll,
      searchError,
      goToPanel,
      next,
      preview,
      current_page,
      go_page,
      last_page,
      one_more,
      one_less,
      last,
      total_users,
      all_data,
      go_to,searchUser_data
    };
  },
};
</script>
<style lang="scss" scoped>
.summary {
  background-color: #fff;
  font-size: 0.9rem;
  font-weight: lighter;
  min-height: 50vh;
  /* width: 100vw; */
}

.search-section {
  padding-bottom: 0.5rem;
  max-width: 300px;
}

table {
  border-collapse: separate;
  border-spacing: 0px;
  width: 100%;
  table-layout: auto;
  text-align: center;
}

td {
  border: 1px solid rgba(127, 127, 127, 0.2);
  white-space: nowrap;
  padding-right: 1rem;
}

tr {
  width: 100%;
}

.big-cell {
  width: 75%;
  padding: 0.5rem 1rem 0.5rem 1rem;
}

.small-cell {
  float: right;
  width: calc(100% / 7);
  padding: 0.5rem 1rem 0.5rem 1rem;
  text-align: center;
  min-width: 100px;
}
.headline {
  border-bottom: solid 1px #f1f0f0;
  overflow: auto;
  white-space: nowrap;
}
.page-keys {
  outline: none;
  padding: 15px;
  margin: 0 3px;
  display: inline-block;
  border-radius: 10px;
  border: solid 1px rgb(204, 204, 204);
  color: gray;
  &.active {
    background: rgb(89, 171, 238);
    color: white;
  }
}
.go-to-btn {
  margin: 0 10px;
  border-radius: 5px;
  padding: 7px;
  font-size: 13px;
  color: white;
  background: #59abee;
  outline: none;
}
.go-to-input {
  border: solid 1px #f0f0f0;
  border-radius: 5px;
  width: 45px;
  outline: none;
  min-height: 35px;
  padding: 5px 0;
  text-align: left;
  color: gray;
  text-align: center;
}
</style>